module.exports = __webpack_public_path__ + "img/20.fa6ae35c.png";